module.exports = __webpack_public_path__ + "img/ng.500aadeb.svg";